export default __webpack_public_path__ + "static/media/nothingHere.f21524af.gif";